export const APP_URI = "https://medhatrust.org:8080/api";
